/**
 * Streaming indicator — shown below the assistant turn while tokens are
 * being received. Rotates through generic "thinking" phrases (Claude-Code
 * style) every 3s so the wait feels alive without making false claims
 * about specific work.
 */
import { LoadingPhrase } from '../../../components/ui';

export function ChatStreamingIndicator() {
  return (
    <div className="px-4 py-2">
      <LoadingPhrase kind="chat" className="text-body-sm text-txt-tertiary" />
    </div>
  );
}
